export * from './lib/store-consumption-form';
